import { useDispatch, useSelector } from "react-redux";
import useCookie from "react-use/lib/useCookie";
import { useContext, useEffect } from "react";
import { Context } from 'context/context';
import { statusIsGood } from "lib/middleware/errors";
import buttons from "components/_styled/buttons.module.css";

import { COOKIE_CONSENT_STATE} from "_constants";
import { cookieUpdateState } from "_slices/auth";
import styles from "./cookieMessage.module.css"

type Props = {
  text?: string;
};

type state = {
  auth: {
    cookieConsentGiven: boolean
  }
}

const CookieMessage = ({ text }: Props) => {
  const dispatchRedux = useDispatch();
  const [consentCookie, setConsentCookie] = useCookie(COOKIE_CONSENT_STATE);

  const {cookieConsentGiven } = useSelector((state: state) => state.auth);
  const { dispatch, state } = useContext(Context);

  const hasCookies = consentCookie === "1";

  const updateCookie = (newState: number) => {
    setConsentCookie(newState.toString());
    dispatchRedux(cookieUpdateState(newState));
    let cookie = document.getElementById('cookie');
    if (cookie && cookie.classList.contains('visiableCookie')) {
      cookie.classList.remove('visiableCookie')
      cookie.classList.add('displayNoneCookie')
    }
    //  
  };

  // Consent Cookie checking
  const consentCookieCheck = () => {
    // If there is no cookie or an
    if (consentCookie === null) {
      updateCookie(-1);
      return false;
    }
    updateCookie(parseInt(consentCookie));
    return true;
  };

  // Auth cookie checking
  const authCookieCheck = async () => {
    if (hasCookies) {
     const response = await fetch(`${process.env.NEXT_PUBLIC_CR_JS_API}auth/status`, {
        method: 'GET',
        headers: new Headers({ 'content-type': 'application/json' }),
        credentials: "include"
      })
      response.json()
      .then((res) => {
        if (statusIsGood(response.status) && res.user) {
          dispatch({
            type: "LOGGED_IN_USER",
            payload: res.user
          })
        }
      })
    }
  };

  // Whenever the cookie consent changes run the check again
  useEffect(() => {
    consentCookieCheck();
    authCookieCheck();
    if (document && (cookieConsentGiven.toString() === '-1')) {
      let cookie = document.getElementById('cookie');
      if (cookie) {
        cookie.classList.remove('displayNone')
        setTimeout(() => {
          cookie.classList.add('visiableCookie')
        }, 100)
      }
    }
  }, [consentCookie]);

  // When the app loads check the authCookie
  // useEffect(() => {
  //   authCookieCheck();
  // }, []);

  // if (cookieConsentGiven !== -1) return null;
  let message = text ? text : "Completely Retail uses cookies to improve user experience and performance. ";

  return (
    <div className={`${styles.Container} displayNoneCookie`} id="cookie">
      <div className={styles.Message}>
        {message}
        <a href="https://completelygroup.com/privacy-cookies" target="_blank" rel="noopener noreferrer">
          Our full cookie policy can be found here
        </a>
      </div>
      <div className={styles.Response}>
        <button className={buttons.SecondaryButton} id="accept-cookie"  onClick={() => updateCookie(1)}>I accept</button>
        <button className={`${styles.ExtaMargin} ${buttons.TertiaryButton}`} onClick={() => updateCookie(0)}>I do not accept</button>
      </div>
    </div>
  );
};

export default CookieMessage;
